import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/smartID/banner_img.webp";

function Banner() {
  return (
    <section
      className="banner_h100 smartid_banner "
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#fff" }}>Smart ID app development</h1>
            <p style={{ color: "#fff" }}>
              The best technology is simple, yet functional. That’s what we
              wanted to bring out in the SmartID, through a unique blend of
              minimalist design and elevated performance.
            </p>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
